var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{style:({ fill: _vm.color }),attrs:{"xmlns":"http://www.w3.org/2000/svg","stroke":"black","stroke-width":"1","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5.782 0c-6.059 11.831 4.489 22.204 16.18 16.211l-16.18-16.211zm-2.782 20 0-10c1-1-1 6 12 10zm9-15 5 5 0-5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }